// extracted by mini-css-extract-plugin
export default {"overflowContent":"ContentEntryToCopy_overflowContent__D3mqq"};